import request from '@/utils/request'
import store from '@/store/index'
var http = process.env.BASE_API;
var big_data = "https://bigdata.q12301.com"
var qianjing_service = "https://qianjing.dev.ioing.uk:8443"
function getQianjingToken(){
    if(store && store.state && store.state.token){
        return store.state.token
    }
    if(typeof window !== 'undefined' && window.sessionStorage){
        return window.sessionStorage.getItem('token') || ''
    }
    return ''
}
function getQianjingHeaders(){
    var token = getQianjingToken()
    return token ? { Authorization: 'Token ' + token } : {}
}
//实时游客数据
export function realTouristsData(query) {
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/real_tourists_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData);
        }
    })
}
//获取历史游客数据
export function historyTouristsData(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/history_tourists_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//获取游客性别及时间安排
export function genderScheduleData(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/gender_schedule_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//获取天气
export function weatherData(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:http + '/big-data/weather_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
export function weatherDataNew(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:'http://icb-api-test.q12301.com/big-data/weather_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//游客入园时间统计
export function enrollmentTimeData(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_enrollment_time_statistics_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//获取客源地(省份/城市)数据
export function originList(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_origin_list_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//飞机图
export function planeFigure(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_plane_figure_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//游客进出园时间分析
export function currentTrafficTrend(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/current_traffic_trend_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//游客客流分析
export function realTimeTraffic(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_real_time_traffic_list_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//入园游客类型统计
export function ticketNumberStatistics(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_ticket_number_statistics_list_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//根据ID获取景区大数据参数设置详情
export function getSettingByIdApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_setting_by_id_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 客源结构分析
export function getDataCustomerSourceMarketApi(data){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_data_customer_source_market_api/',
            method:'post',
            data
        })
        if(true){
            resolve(returnData)
        }
    })
}
export function getAnalysisMonthApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_analysis_month_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 主体客源市场 
export function getDataMainSourceMarketApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_data_main_source_market_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 今日交易总额
export function getTradingNumApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_trading_num_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 旅行社交易排名
export function getTouristAgencyType(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_tourist_agency_type/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 销售数量占比、销售金额占比
export function getSalesNumApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_sales_num_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 获取酒店信息
export function xcxGetHotelDataApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/xcx_get_hotel_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//获取商户相关
export function getMerchantOrder(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_merchant_order_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
//商户统计排序
export function getMerchantOrderList(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_merchant_order_list_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// // // 线下销售
export function getBigDataOfflineRetailInfo(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:http + '/big-data/get_big_data_offline_retail_info/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 30天销售额对比图
export function salesComparisonApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/sales_comparison_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 复游
export function getDataRepurchaseAnalysisApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_data_repurchase_analysis_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 近七天带入园数
export function getWaitingInApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_waiting_in/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 餐饮数据
export function xcxGetDeliciousFoodDataApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/xcx_get_delicious_food_data_api/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
export function getCoefficientDataSettingApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:big_data + '/big-data/get_coefficient_data_setting/',
            method:'get',
            params:query
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 业态资源 - 获取类型汇总列表
export function getMapResourceApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:http + '/service/get_map_resource/',
            method:'get',
            params:query,
            headers:getQianjingHeaders()
        })
        if(true){
            resolve(returnData)
        }
    })
}
// 业态资源 - 获取类型点位列表
export function getMapPointListApi(query){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:http + '/service/get_map_point_list/',
            method:'get',
            params:query,
            headers:getQianjingHeaders()
        })
        if(true){
            resolve(returnData)
        }
    })
}
//登录
export function loginApi(data){
    return new Promise((resolve,reject)=>{
        var returnData = request({
            url:http + '/big-data/pc-big-data-login-api/',
            method:'post',
            data
        })
        if(true){
            resolve(returnData)
        }
    })
}



// WEBPACK FOOTER //
// ./src/api/ScenicAPI.js